// src/pages/JoinUs.jsx
import React from "react";
import { useLangTranslation } from "../utils/translation";

export default function JoinUs() {
  const t = useLangTranslation('joinus');

  return (
    <section className="joinus-section">
      {/* Hero 섹션 */}
      <div className="joinus-hero">
        <div className="joinus-hero-content">
          <h1 className="joinus-title">{t('hero.title')}</h1>
          <p className="joinus-subtitle">{t('hero.subtitle')}</p>
        </div>
      </div>

      {/* 본문 섹션 */}
      <div className="joinus-content">
        {/* 인용구 */}
        <div className="joinus-quote-section">
          <blockquote className="joinus-quote" dangerouslySetInnerHTML={{ __html: t('quote.text') }} />
        </div>

        {/* 채용 정보 */}
        <div className="joinus-info">
          <div className="joinus-status">
            <h2 className="joinus-status-title">{t('status.title')}</h2>
            <p className="joinus-status-text" dangerouslySetInnerHTML={{ __html: t('status.text') }} />
          </div>

          <div className="joinus-contact">
            <h2 className="joinus-contact-title">{t('contact.title')}</h2>
            <a href="mailto:siwon.oh@play-edge.com" className="joinus-email">
              {t('contact.email')}
            </a>
            <p className="joinus-contact-text">
              {t('contact.text')}
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="joinus-cta">
          <p className="joinus-cta-text">{t('cta.text')}</p>
          <a href="mailto:siwon.oh@play-edge.com" className="joinus-cta-button">
            {t('cta.button')}
          </a>
        </div>
      </div>
    </section>
  );
}

